import { render, staticRenderFns } from "./RetailItemEdit.vue?vue&type=template&id=8f4a1bde&scoped=true&"
import script from "./RetailItemEdit.vue?vue&type=script&lang=js&"
export * from "./RetailItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./RetailItemEdit.vue?vue&type=style&index=0&id=8f4a1bde&prod&lang=scss&scoped=true&"
import style1 from "./RetailItemEdit.vue?vue&type=style&index=1&id=8f4a1bde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4a1bde",
  null
  
)

export default component.exports